import React from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { FilterList } from "@mui/icons-material";
import { useActiveFilterLabels } from "../hooks";
import ActiveFilterLabel from "./ActiveFilterLabel";

interface FilterButtonProps {
  hiddenFilters?: Array<
    | "region"
    | "workstream"
    | "programme"
    | "site"
    | "worktype"
    | "worktype-group"
    | "projectYear"
    | "stakeholder"
    | "project_status"
  >;
  onClick: () => void;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  hiddenFilters = [],
  onClick,
}) => {
  const { hasActiveFilters, activeFilterLabels } =
    useActiveFilterLabels(hiddenFilters);

  return (
    <Tooltip
      title={
        hasActiveFilters && (
          <Box sx={{ p: 0.5 }}>
            <ActiveFilterLabel labels={activeFilterLabels} />
          </Box>
        )
      }
      placement="bottom-start"
      disableHoverListener={!hasActiveFilters}
      arrow
    >
      <Button
        startIcon={<FilterList />}
        variant={hasActiveFilters ? "contained" : "text"}
        color={hasActiveFilters ? undefined : "inherit"}
        onClick={onClick}
        sx={
          hasActiveFilters
            ? {
                backgroundColor: "action.selected",
                color: "text.primary",
                "&:hover": { backgroundColor: "action.hover" },
              }
            : undefined
        }
      >
        {`FILTERS${
          hasActiveFilters ? ` (${activeFilterLabels.length})` : ""
        }`}
      </Button>
    </Tooltip>
  );
};
